import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar'

const Header = ({ phoneNumber }) => {

    return (
        <div>
            <Navbar bg="light" expand="lg">
                <h5 className="mb-0">Customer Phone Number Lookup</h5>
                <Nav className="mr-auto ml-auto">
                    <Nav.Link>
                        <img width="300" src="/protectall-logo.png" alt="logo" />
                    </Nav.Link>
                </Nav>
                <Nav className="ml-auto">
                    <Nav.Link href={"tel:" + phoneNumber}>Incoming Phone Number: {phoneNumber}</Nav.Link>
                </Nav>
            </Navbar>
        </div>
    );
};

export default Header;